import { Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts';

const Pie = ({ values = {} }) => {
  const size = 250;
  const STATUS_MAP = {
    1: { label: 'PENDENTE', color: '#FFA726' },
    6: { label: 'CONCLUÍDO', color: '#66BB6A' },
    17: { label: 'ENVIADO', color: '#42A5F5' },
    19: { label: 'NÃO APROVADO', color: '#EF5350' },
    20: { label: 'FATURAMENTO LIBERADO', color: '#26A69A' },
    21: { label: 'AGUARDANDO PEÇAS', color: '#8D6E63' },
    25: { label: 'À ENVIAR', color: '#FFCA28' },
    26: { label: 'EQUIPAMENTO DISPONIVEL', color: '#5C6BC0' },
    27: { label: 'EQUIPAMENTO DESCARTADO', color: '#EC407A' },
    30: { label: 'DIGITAÇÃO', color: '#29B6F6' },
    45: { label: 'EM EXECUÇÃO', color: '#AB47BC' },
    aprovados: { label: 'APROVADOS', color: '#2E7D32' },
    reprovados: { label: 'REPROVADOS', color: '#C62828' },
  };

  const formatPieData = () => {
    return Object?.entries(values)?.map(([id, value]) => {
      const statusInfo = STATUS_MAP[id] || {
        label: 'Desconhecido',
        color: '#9E9E9E',
      };
      return {
        id: isNaN(+id) ? id : +id,
        value,
        label: statusInfo.label,
        color: statusInfo.color,
      };
    });
  };

  const data = formatPieData();

  if (data?.every((e) => e?.value === 0)) {
    return (
      <Typography variant="subtitle2" textAlign="center" fontWeight="normal">
        Nenhum registro encontrado
      </Typography>
    );
  }

  return (
    <PieChart
      height={size}
      margin={{ right: size }}
      series={[{ data: formatPieData(), innerRadius: 30 }]}
      slotProps={{
        legend: {
          position: { horizontal: 'right', vertical: 'middle' },
          labelStyle: { fontSize: 12 },
        },
      }}
    />
  );
};
export default Pie;
